import React from 'react'
import './LandingStyles.css'

const Landing = () => {
  return (
    <div className="hero">
        <div className="mask">
            <img src="https://images1.loopnet.com/i2/_gmYyggoYy5kfeuaiHik1XdGbMYOsq2VZOME0IQ5JhE/112/image.jpg" alt="man fixing car" className='intro-img' />
        </div>
        <div className="content">
            <h1>Welcome to Belgrade Auto!</h1>
            <p>Complete Foreign & Domestic Auto Repair and Service</p>
            <p>Roslindale, Ma</p>
        </div>
    </div>
  )
}

export default Landing